module.exports = __webpack_public_path__ + "static/media/building_dashboard.a576fe3b.svg";